/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-transaction.reducer';

export const AccountingTransactionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingTransactionEntity = useAppSelector(state => state.accountingTransaction.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingTransactionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingTransaction.detail.title">AccountingTransaction</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingTransactionEntity.id}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.type">Type</Translate>
            </span>
            <UncontrolledTooltip target="type">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.type" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.type}</dd>
          <dt>
            <span id="transactionNumber">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.transactionNumber">Transaction Number</Translate>
            </span>
            <UncontrolledTooltip target="transactionNumber">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.transactionNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.transactionNumber}</dd>
          <dt>
            <span id="paidAt">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.paidAt">Paid At</Translate>
            </span>
            <UncontrolledTooltip target="paidAt">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.paidAt" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.paidAt}</dd>
          <dt>
            <span id="amount">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.amount">Amount</Translate>
            </span>
            <UncontrolledTooltip target="amount">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.amount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.amount}</dd>
          <dt>
            <span id="currencyRate">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.currencyRate">Currency Rate</Translate>
            </span>
            <UncontrolledTooltip target="currencyRate">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.currencyRate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.currencyRate}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.description}</dd>
          <dt>
            <span id="reconciled">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.reconciled">Reconciled</Translate>
            </span>
            <UncontrolledTooltip target="reconciled">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.reconciled" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.reconciled ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.timestampEntry}</dd>
          <dt>
            <span id="resultingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.resultingBalance">Resulting Balance</Translate>
            </span>
            <UncontrolledTooltip target="resultingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.resultingBalance" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.resultingBalance}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.createdById">Created By Id</Translate>
            </span>
            <UncontrolledTooltip target="createdById">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.createdById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.createdByType">Created By Type</Translate>
            </span>
            <UncontrolledTooltip target="createdByType">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.createdByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingTransactionEntity.createdByType}</dd>
          <dt>
            <span id="pharmacySupplierId">
              <Translate contentKey="tinyMedicRestApp.accountingTransaction.pharmacySupplierId">Pharmacy Supplier Id</Translate>
            </span>
          </dt>
          <dd>{accountingTransactionEntity.pharmacySupplierId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.account">Account</Translate>
          </dt>
          <dd>{accountingTransactionEntity.account ? accountingTransactionEntity.account.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.category">Category</Translate>
          </dt>
          <dd>{accountingTransactionEntity.category ? accountingTransactionEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.paymentMethod">Payment Method</Translate>
          </dt>
          <dd>{accountingTransactionEntity.paymentMethod ? accountingTransactionEntity.paymentMethod.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.currency">Currency</Translate>
          </dt>
          <dd>{accountingTransactionEntity.currency ? accountingTransactionEntity.currency.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.tax">Tax</Translate>
          </dt>
          <dd>
            {accountingTransactionEntity.taxes
              ? accountingTransactionEntity.taxes.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingTransactionEntity.taxes && i === accountingTransactionEntity.taxes.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.transaction">Transaction</Translate>
          </dt>
          <dd>
            {accountingTransactionEntity.transactions
              ? accountingTransactionEntity.transactions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingTransactionEntity.transactions && i === accountingTransactionEntity.transactions.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.parent">Parent</Translate>
          </dt>
          <dd>{accountingTransactionEntity.parent ? accountingTransactionEntity.parent.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.reconciliation">Reconciliation</Translate>
          </dt>
          <dd>
            {accountingTransactionEntity.reconciliations
              ? accountingTransactionEntity.reconciliations.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingTransactionEntity.reconciliations && i === accountingTransactionEntity.reconciliations.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/accounting-transaction" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-transaction/${accountingTransactionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingTransactionDetail;
